/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type PdpSharedDetail_detailValues$ref = any;
export type PdpSharedDetail_detailValues = ReadonlyArray<{
    readonly detailKey: string | null;
    readonly browseUrl: string | null;
    readonly displayName: string | null;
    readonly linkOrder: number | null;
    readonly skuId: string | null;
    readonly price?: {
        readonly convertedAmountList: ReadonlyArray<{
            readonly currency: Currency | null;
            readonly amount: number | null;
        } | null> | null;
    } | null;
    readonly " $refType": PdpSharedDetail_detailValues$ref;
} & ({
    readonly price: {
        readonly convertedAmountList: ReadonlyArray<{
            readonly currency: Currency | null;
            readonly amount: number | null;
        } | null> | null;
    } | null;
} | {
    /*This will never be '% other', but we need some
    value in case none of the concrete values match.*/
    readonly __typename: "%other";
})>;



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedDetail_detailValues",
    "type": "PdpDetailValueInterface",
    "metadata": {
        "plural": true
    },
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "detailKey",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "browseUrl",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "displayName",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "linkOrder",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "skuId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "InlineFragment",
            "type": "PdpDetailVersionsValue",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "price",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "convertedAmountList",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ConvertedAmountList",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "currency",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "amount",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'cbd47d748c0c2581f50dd53cd7fa3160';
export default node;
